import EventActionProto from '../event-action-proto';
import CrmAccountCollectionSession from "../../model2/crm/account/session/collection-session";

export default class SessionCrmAccount extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId);

        this.method = sessionEvent.method;
        this.fromSID = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        switch (this.method) {
            case 'reset': gd.session._crmAccounts = new CrmAccountCollectionSession(this.data); break;
            default:
                this._updateSessionCollection();
                this._sendBusUpdate();
                break;
        }
    }

    _updateSessionCollection() {
        // if user never initialized session.crmContacts we don't update it
        if (!gd.session.crmAccounts) return false;

        gd.session.crmAccounts.applyDelta(this.method, this.data);
    }

    _sendBusUpdate() {
        // send
        gd.modelBus.newUpdate('crm-account', this.method, this.data.id, this.data);
    }
}
